import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getAvatarColor, getInitials } from './utils';

const Circle = styled.div`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  background: ${({ bgColor }) => bgColor};
  color: var(--if-on-accent);
  font-weight: 700;
  font-size: ${({ size }) => Math.round(size * 0.4)}px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;
`;

export default function UserAvatar({ name, size = 24 }) {
  return (
    <Circle size={size} bgColor={getAvatarColor(name)}>
      {getInitials(name)}
    </Circle>
  );
}
UserAvatar.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
};
